import PropTypes from "prop-types";
import React from "react";
import IllustrationRdcBuyerDemand from "../../illustrations/IllustrationRdcBuyerDemand";
import Preview from "./LivePreview";

function LivePreviewRdcBuyerDemand({ title }) {
  return (
    <Preview
      illustration={<IllustrationRdcBuyerDemand />}
      title={title}
      subTitle="How strong is buyer demand?"
    />
  );
}

LivePreviewRdcBuyerDemand.propTypes = {
  title: PropTypes.string.isRequired
};

export default LivePreviewRdcBuyerDemand;
